import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

function Category13() {
  const [data, setData] = useState([]);

  useEffect(() => {
    axios
      .get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/coursecategoriessort") // Update with actual backend URL
      .then((response) => {
        setData(response.data); // Store response in state
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);

  return (
    <section className="testimonials-category-section" style={{ paddingTop: "20px", paddingBottom:"0px" }}>
      <div className="tf-container">

     

        <div className="row">
          <div className="col-md-12">
            <div className="tf-title style-2"  style={{marginBottom:"20px"}}>
              <div className="group-title">
                <h1  style={{ marginBottom: "0px", fontSize:"30px" }}>Master The Art Of Astrology</h1>
                <p>
                  Trusted Expert Courses in Vedic and Modern Astrology
                </p>
              </div>
            </div>
          </div>

          <div className="col-md-12">
            <div className="row">
              {data.map((item, index) => (
                <div key={index} className="col-lg-3 col-md-4 col-6">
                  <div className="group-category-job padding wow fadeInUp" style={{paddingBottom:"10px"}}>
                  <Link to={`/course-category-details/${item.Id}`}>
                    <div className="job-category-box" style={{width:"unset", padding:"18px"}}>
                      <div className="job-category-header" style={{marginBottom:"0px"}}>
                        <img
                          src={item.Path1 || "default-image.jpg"} // Use Path1 for image
                          alt={item.Named}
                          style={{ width: "100%", height: "auto", borderRadius: "10px" }}
                        />
                        <h1 style={{marginTop:"15px", fontWeight: "600", 
    fontSize:"16px"}}>
                          <Link to={`/course-category-details/${item.Id}`}>{item.Named}</Link>
                        </h1>
                       
                      </div>
                    <Link to={`/course-category-details/${item.Id}`} className="btn-category-job">
                                                Know More
                                                <span className="icon-keyboard_arrow_right"></span>
                                              </Link>
                     
                    </div>
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Category13;